export enum Language {
    nl = 'nl',
    fr = 'fr',
}
